const MV_SELECTOR = ".mv";
const STICKY_SELECTOR = ".js-sticky-cta";
const VISIBLE_CLASS = "is-sticky-cta-visible";

export const stickyCta = () => {
  const mv = document.querySelector(MV_SELECTOR);
  const sticky = document.querySelector(STICKY_SELECTOR);
  if (!mv || !sticky) return;

  const observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      // MVがビューポート50%より上に出たら表示
      const show = !entry.isIntersecting;
      sticky.classList.toggle(VISIBLE_CLASS, show);
      sticky.setAttribute("aria-hidden", show ? "false" : "true");
    },
    {
      rootMargin: "-50% 0px 0px 0px",
    },
  );

  observer.observe(mv);
};
